import { InputField, LabelField, SelectField } from "components";
import { getDateFormatForDatePicket } from "helper/dateFormat";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ReactFormBuilder } from "react-form-builder2";
import "react-form-builder2/dist/app.css";
import * as variables from "utils/ReactFormBuilderVariables";
import { fontConfig } from "theme/fontConfig";


function FormBuilder({ formik, getFormByIdHandler, onSetFormHandler, checkUpdateType }) {
  const dateFormat = getDateFormatForDatePicket();
  const items = [
    { key: "Header" },
    { key: "Label" },
    { key: "Paragraph" },
    { key: "LineBreak" },
    { key: "Dropdown" },
    { key: "Checkboxes" },
    { key: "RadioButtons" },
    { key: "TextInput" },
    { key: "EmailInput" },
    { key: "NumberInput" },
    { key: "PhoneNumber" },
    { key: "TextArea" },
    {
      key: "DatePicker",
      dateFormat: dateFormat,
    },
    { key: "FileUpload" },
    { key: "HyperLink" },
    { key: "TwoColumnRow" },
    { key: "ThreeColumnRow" },
  ];
  return (
    <div className="class__form__builder">
      {/* required field */}
      <LabelField
        title="Required Fields"
        mandatory={true}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          textAlign: "center",
          fontSize: "16px",
        }}
      />
      <Row style={{ marginBottom: "10px" }}>
        <Col className="col-sm-4">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: "400",
              fontSize: "12px",
              lineHeight: "18px",
              color: "#4F4F4F",
            }}
            style={{ background: "#f2f5f7", color: "#002E5C", height: "54px" }}
            mandatory={true}
            formik={formik}
            title={"First Name"}
            name="costInfo_amount"
            checkValidation={true}
            readOnly
          />
        </Col>
        <Col className="col-sm-4">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: "400",
              fontSize: "12px",
              lineHeight: "18px",
              color: "#4F4F4F",
            }}
            style={{ background: "#f2f5f7", color: "#002E5C", height: "54px" }}
            mandatory={true}
            formik={formik}
            title={"Last Name"}
            name="costInfo_amount"
            checkValidation={true}
            readOnly
          />
        </Col>
        <Col className="col-sm-4">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: "400",
              fontSize: "12px",
              lineHeight: "18px",
              color: "#4F4F4F",
            }}
            style={{ background: "#f2f5f7", color: "#002E5C", height: "54px" }}
            mandatory={false}
            formik={formik}
            title={"Phone Number"}
            name="phone_number"
            checkValidation={true}
            readOnly
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: "20px" }}>
        <Col className="col-sm-4">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: "400",
              fontSize: "12px",
              lineHeight: "18px",
              color: "#4F4F4F",
            }}
            style={{ background: "#f2f5f7", color: "#002E5C", height: "54px" }}
            mandatory={true}
            formik={formik}
            title={"Email"}
            name="email"
            checkValidation={true}
            readOnly
          />
        </Col>
      </Row>
      <ReactFormBuilder
        variables={variables}
        edit
        toolbarItems={items}
        url={``}
        onPost={onSetFormHandler}
        onLoad={(checkUpdateType()) ? getFormByIdHandler : null}
      />
    </div>
  );
}

export default FormBuilder;
